import { render } from "./AddAvatarIcon.vue?vue&type=template&id=4eec0cd2"
import script from "./AddAvatarIcon.vue?vue&type=script&lang=js"
export * from "./AddAvatarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__